<template>
    <LayoutForm>
        <div class="sector-edit">
            <h1>Edit Sector</h1>
            <div class="sector-edit__wrapper">

                <form class="form" @submit.prevent="submit" novalidate>
                    <ValidationAlert :error-list="errors"></ValidationAlert>

                    <FormControlSector
                        name="sectors"
                        v-model="sector"
                        :multiple="false"
                        :include-ancestors="false"
                    />

                    <div class="sector-edit__new" v-if="sector !== null">
                        <div class="form__group">
                            <input id="name" name="name" class="form__control" v-model="formData.new_title" @input="slugify_field(formData.new_title)"
                            placeholder="Enter a new name for this sector..." v-validate required />
                            <label for="name" class="form__label">New Name</label>
                            <div class="form__validation"></div>
                        </div>
                        <div class="form__group">
                            <input id="slug" name="slug" class="form__control" v-model="formData.new_slug"
                            placeholder="Enter a new slug for this sector..." v-validate required />
                            <label for="slug" class="form__label">New Slug</label>
                            <div class="form__validation"></div>
                        </div>

                        <div class="form__group form__group--submit">
                            <button class="btn btn--primary" v-wait:disabled='"submit"'>Save &amp; Continue</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </LayoutForm>
</template>

<script>
import FilterableList from '../List/FilterableList'
import FormControlSector from '../Form/Control/FormControlSector';
import LayoutForm from '../Layout/LayoutForm';
import API from '../../api';
import ValidationAlert from '../ValidationAlert';
import slugify from 'slugify';
import FileUpload from '@components/Form/FileUpload.vue';
//TODO: Ensure only admins can see this component.
export default {
    name: "SectorEditAll",
    mixins: [FilterableList, ValidationAlert],
    components: {
        FileUpload,
        FormControlSector,
        ValidationAlert,
        LayoutForm
    },
    data() {
        return {
            sector_list: this.sectors || [],
            displayed: false,
            sector: null,
            //where the data from the forms is sent to.
            formData: {
                new_title: null,
                new_slug: null,
            },
            errors: []
        }
    },
    props: {
        errorList: {
            type: Object,
            default: () => {}
        }
    },
    watch: {
        'sector' : function(newVal, oldVal) {
            // console.log('value changed from ' + oldVal + ' to ' + newVal);
            API.getSector(newVal).then(response => {
                // console.log("You have selected ", response)
                this.formData.new_title = response.name;
                this.formData.new_slug = response.slug;
            }).catch(() => {
                this.error = true;
            })
        }
    },
    methods: {
        load() {
            //if no sectors are set, load them in from the API.
            if(!this.sectors) {
                this.loading = true;

                API.getSectors().then(response => {
                    this.loaded = true;
                    this.sector_list = response;
                    // console.log("Retrieved sectors: ", this.sector_list);
                }).catch(() => {
                    this.error = true;
                }).finally(() => {
                    this.loading = false;
                });
            }
        },

        submit(e) {
            this.errors = [];

            if(this.formData.new_title === null || this.formData.new_title === '') {
                this.errors.push("New Title is required")
            }
            if(this.formData.new_slug === null || this.formData.new_slug === '') {
                this.errors.push("New Slug is required.")
            }

            //if we have no errors publish the
            if(this.errors.length === 0) {
                this.formData.new_slug = slugify(this.formData.new_slug).toLowerCase();

                API.updateSector(this.sector, this.formData).then((res) => {
                    console.log("Recieved response: ", res);
                    this.$router.push('/sectors');
                })
                .catch(error => {
                    API.mapServerValidation(error.response, this.$validator);
                });
            }

            // console.log(this.errors);
        },

        slugify_field(text) {
            this.formData.new_slug = slugify(text).toLowerCase();
        }
    },
    created() {
        this.load();
    }
}
</script>

<style lang="scss" scoped>
    @import '~reflex-grid/scss/includes/variables';
	@import '~reflex-grid/scss/includes/mixins';
	@import '~@/theme/_variables.scss';
	@import '~@/mixins/_class.scss';
	@import '~@/theme/_extenables.scss';
</style>

